import { de } from "date-fns/locale";
import React, {useEffect, useState} from "react";
import { ReactComponent as Logo } from "../svg/logo/sha/logo.svg";

const RegisterPrensentationFinish = (props: any) => {

    return (
        <div
        style={{height : "100vh"}}
        >
            <div 
            style={{ maxWidth: "500px", margin: "0 auto", width: "91.4%", height : "100%",display : "flex", justifyContent : "center", alignItems : "center" }}
            >
                <div
                style={{
                    fontSize : "21px",
                    fontWeight : 700,
                    textAlign : "center",
                    lineHeight : "1.4"
                }}
                >
                    신청해주셔서 감사합니다!<br></br><br></br>
                    <Logo style={{ width: "140px" }} />
                </div>
            </div>
        </div>
    );
}

export default RegisterPrensentationFinish;